export const userProfile = {
    client: 'Cliente',
    analyst: 'Analista',
    analyst_client: 'Cliente Analista'
};
